// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "promo__content-2OrWQ";
var _3 = "promo-1WC6J";
var _4 = "promo__icon-1qpkC";
var _5 = "promo__image-UosII";
export { _1 as "__esModule", _2 as "promo__content", _3 as "promo", _4 as "promo__icon", _5 as "promo__image" }
export default { "__esModule": _1, "promo__content": _2, "promo": _3, "promo__icon": _4, "promo__image": _5 }
